export default [
  {
    title: 'Get Started',
    link: '/docs/getting-started'
  },
  {
    title: 'Custom layer',
    link: '/docs/custom-layer'
  },
  {
    title: 'Charts',
    link: '/docs/charts',
    children: [
      { title: 'Line Chart', link: '/docs/charts/line' },
      { title: 'Bar Chart', link: '/docs/charts/bar' },
      { title: 'Area Chart', link: '/docs/charts/area' },
      { title: 'Pie Chart', link: '/docs/charts/pie' }
    ]
  },
  {
    title: 'Types',
    link: '/docs/types'
  }
]
